import { Component } from '@angular/core';

@Component({
    selector: 'bb-payment-card-number-pipe-page-ui',
    templateUrl: './bb-payment-card-number-page-ui.component.html',
    standalone: false,
})
export class PaymentCardNumberPageComponent {}
